import React from 'react';
import { useTranslation } from 'react-i18next';

import './Banner.scss';

import icon from '../../assets/banner/icons/Calling.webp';
import bannerImg from '../../assets/banner/1.webp';

const Banner = () => {
    const { t } = useTranslation();

    return (
        <section className="section-bg section-common banner-section">
            <div className="d-table">
                <div className="d-table-cell">
                    <div className="container">
                        <div className="row">

                            <div className="col-lg-6">
                                <div className="banner-text">

                                    <h1>
                                        {t('banner.title')}
                                    </h1>

                                    <p>
                                        {t('banner.description')}
                                    </p>

                                    <div className="banner-bottom">

                                        <div className="theme-btn">
                                            <a
                                                href="https://dr-flex.de/embed?medicalPracticeId=53366"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {t('banner.appointment')}
                                            </a>
                                        </div>

                                        <a
                                            href="tel:01805986700"
                                            className="banner-call"
                                        >
                                            <div className="icon">
                                                <img
                                                    src={icon}
                                                    alt={t('banner.emergencyAlt')}
                                                />
                                            </div>

                                            <div className="call-text">
                                                <p>
                                                    {t('banner.emergency')}
                                                </p>

                                                <h6>
                                                    01805 986700
                                                </h6>
                                            </div>
                                        </a>

                                    </div>

                                </div>
                            </div>

                            {/* Nur Desktop sichtbar */}
                            <div className="col-lg-6 banner-image-column">
                                <div className="banner-img-area">

                                    <div className="banner-img">
                                        <img
                                            src={bannerImg}
                                            alt={t('banner.imageAlt')}
                                        />
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;